import { SPIN_RESPONSE_DATA, SPINE_RESPONSE } from '../../stateManagment';
import { BehaviorSubject } from 'bog-arcade-core-ui/observer/BehaviorSubject';

export class SpinResponseService {
  constructor() {
    this.SPIN_STARTED = new BehaviorSubject(false);
    this.spinResponse = null;
    this.spinError = null;
  }

  notNull() {
    return SPINE_RESPONSE.getValue() !== null;
  }

  nullify() {
    SPINE_RESPONSE.next(null);
  }

  getData() {
    return SPINE_RESPONSE.getValue();
  }

  startSpin() {
    this.SPIN_STARTED.next(true);
  }

  stopSpin() {
    this.SPIN_STARTED.next(false);
  }

  setSpinStartedState(val) {
    this.SPIN_STARTED.next(val);
  }

  resetSpinStarted() {
    this.stopSpin();
  }

  get spinStarted() {
    return this.SPIN_STARTED.getValue();
  }

  get isStop() {
    return !this.SPIN_STARTED.getValue();
  }


  get response() {
    return this.spinResponse;
  }

  setResponse(value) {
    this.spinResponse = value;
  }

  resetResponse() {
    this.spinResponse = null;
  }

  get hasError() {
    return this.spinError;
  }

  resetError() {
    this.spinError = null;
  }

  setError(error) {
    this.spinError = error;
  }

  setData(data) {
    SPIN_RESPONSE_DATA.next(data);
  }
}

export const spinResponseService = new SpinResponseService();
